import React from "react";
import { Spinner } from "reactstrap";
import PropTypes from "prop-types"

const ModifyLoadingIcon = (props) => {
  return <Spinner size="sm" color={props.color} />
}

export default ModifyLoadingIcon;

ModifyLoadingIcon.propTypes = {
  color: PropTypes.string
}